export function getMonthNames() {
    return [
        { value: 1, name: 'Styczeń', shortName: 'Sty' },
        { value: 2, name: 'Luty', shortName: 'Lut' },
        { value: 3, name: 'Marzec', shortName: 'Mar' },
        { value: 4, name: 'Kwiecień', shortName: 'Kwi' },
        { value: 5, name: 'Maj', shortName: 'Maj' },
        { value: 6, name: 'Czerwiec', shortName: 'Cze' },
        { value: 7, name: 'Lipiec', shortName: 'Lut' },
        { value: 8, name: 'Sierpień', shortName: 'Szi' },
        { value: 9, name: 'Wrzesień', shortName: 'Wrz' },
        { value: 10, name: 'Październik', shortName: 'Paź' },
        { value: 11, name: 'Listopad', shortName: 'Lis' },
        { value: 12, name: 'Grudzień', shortName: 'Gru' },
    ];
}

export function getMonthName(id) {
    return getMonthNames().find((x) => x.value === id)?.name;
}

export function getMonthShortName(id) {
    return getMonthNames().find((x) => x.value === id)?.shortName;
}